import React from 'react';

const NavContext = React.createContext((source) => {
	return undefined;
});

export default NavContext;
